<template>
    <div>
        <header-bar
            :title="$t('talk.templates')"
            :buttonActionText="$t('talk.form.newTemplate')"
            :noMargin="true"
            @click="onClickCreateTemplate"
        />
        <loader class="mt-3" :loader="isLoading" />
        <div class="not-loading" v-if="!isLoading">
            <div class="list-container" v-if="templates.length">
                <div
                    v-for="template in templates"
                    :key="'template-' + template.id"
                    class="list-item"
                >
                    <template-component
                        :template="template"
                        @update="updateTemplate"
                        @edit="onClickEditTemplate(template)"
                        @delete="onClickDeleteTemplate(template)"
                    />
                </div>
            </div>
            <div class="list-container" v-if="!templates.length">
                <span class="no-template">{{ $t('talk.noTemplateList') }}</span>
            </div>
        </div>
        <router-view
            :template="editingTemplate"
            @template-created="addTemplate"
            @template-updated="updateTemplate"
        />
    </div>
</template>

<script>
import Loader from '@/views/components/loader'
import { proceedWithConfirmation } from '@/lib/sweet-alert'
import notification, { success, danger } from '@/lib/notification'

import { Template as TemplateComponent } from '../components'

import { getTemplatesFromApi, deleteTemplate } from './api'

import { HeaderBar } from '@/views/talk/components'

notification.init()

export default {
    name: 'List',
    components: {
        TemplateComponent,
        Loader,
        HeaderBar,
    },
    data() {
        return {
            templates: [],
            editingTemplate: null,
            isLoading: false,
        }
    },
    mounted() {
        this.getTemplates()
    },
    methods: {
        onClickCreateTemplate() {
            this.$router.push('/v2/feedbacks/templates/new')
        },
        onClickEditTemplate(template) {
            this.editingTemplate = template
            this.$router.push(`/v2/feedbacks/templates/edit/${template.id}`)
        },
        onClickDeleteTemplate(template) {
            proceedWithConfirmation({
                onConfirm: () => deleteTemplate(template.id),
                callback: () => {
                    success(
                        this.$t('notification.deletedSuccessfully', {
                            item: this.$t('talk.template'),
                        })
                    )
                    this.templates = this.templates.filter(
                        ({ id }) => template.id !== id
                    )
                },
                onError: () => danger(),
            })
        },
        addTemplate(template) {
            this.templates.push(template)
        },
        updateTemplate({ id, title, description, askings = [] }) {
            const template = this.templates.find(t => t.id == id)
            const index = this.templates.indexOf(template)
            this.$set(this.templates, index, {
                ...template,
                id,
                title,
                askings,
                description,
            })
        },
        getTemplates() {
            this.isLoading = true
            getTemplatesFromApi()
                .then(res => (this.templates = res))
                .finally(() => (this.isLoading = false))
        },
    },
}
</script>

<style lang="sass" scoped>
.no-template
    color: #6f6f6f

.list-container
    background-color: #ffffff
    padding: 40px 15px
    margin: 10px
    .list-item
        margin-bottom: 25px

@media (min-width: 768px)
    .list-container
        margin: 2rem

@media screen and (min-width: 992px)
    .list-container
        padding: 40px 30px
</style>
